import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Phone, MapPin, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PHONE_DISPLAY = "1 (800) 955-5780";
export const PHONE_HREF = "tel:+18009555780";

const NAV_ITEMS = [
  { label: "Carlisle Products", target: "products", testid: "nav-products-link" },
  { label: "All Products", route: "/products", testid: "nav-all-products-link" },
  { label: "Manufacturers", target: "manufacturers", testid: "nav-manufacturers-link" },
  { label: "Request a Quote", target: "quote", testid: "nav-quote-link" },
];

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goHome = () => {
    setOpen(false);
    if (location.pathname !== "/") navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const go = (item) => {
    setOpen(false);
    if (item.route) {
      navigate(item.route);
      window.scrollTo({ top: 0 });
      return;
    }
    const doScroll = () => {
      const el = document.getElementById(item.target);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(doScroll, 400);
    } else {
      doScroll();
    }
  };

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 bg-navy-900 shadow-lg">
      <div className="bg-navy-950 text-navy-100 text-xs sm:text-sm">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 sm:px-6">
          <span className="flex items-center gap-1.5">
            <MapPin className="h-3.5 w-3.5" /> quadraciti.com
          </span>
          <a
            data-testid="topbar-phone-link"
            href={PHONE_HREF}
            className="flex items-center gap-1.5 font-semibold hover:text-white"
          >
            <Phone className="h-3.5 w-3.5" /> {PHONE_DISPLAY}
          </a>
        </div>
      </div>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6">
        <button
          data-testid="logo-home-button"
          onClick={goHome}
          className="font-display text-2xl font-extrabold tracking-tight text-white"
        >
          QUADRA<span className="text-steel-400">CITI</span>
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.testid}
              data-testid={item.testid}
              onClick={() => go(item)}
              className="text-sm font-semibold text-navy-100 transition-colors hover:text-white"
            >
              {item.label}
            </button>
          ))}
          <Button
            data-testid="header-quote-button"
            onClick={() => go({ target: "quote" })}
            className="bg-steel-500 font-semibold text-white hover:bg-steel-400"
          >
            Get a Quote
          </Button>
        </nav>
        <button
          data-testid="mobile-menu-toggle"
          className="text-white md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="border-t border-navy-700 bg-navy-900 md:hidden">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.testid}
              data-testid={`mobile-${item.testid}`}
              onClick={() => go(item)}
              className="block w-full px-6 py-3 text-left text-sm font-semibold text-navy-100 hover:bg-navy-800 hover:text-white"
            >
              {item.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};
